import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Grid from '../../Grid';
import Typography from '../../Typography';
import Image from '../../Image/Image';
import styles from './ActionIcon.module.sass';

const ActionIcon = ({ icon, text, action, classes }) =>
  <Grid item classes={cn(styles.iconText, classes)} onClick={action}>
    <Typography>
      <Image classes={styles.imgIcon} src={icon} alt='remove icon' />
      {text}
    </Typography>
  </Grid>

ActionIcon.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string,
  action: PropTypes.func,
  classes: PropTypes.string
};

export default ActionIcon;
